import { useState, useEffect } from 'react';
export default function usePixelRatio() {
    const [pixelRatio, setPixelRatio] = useState(1);
    useEffect(() => {
        let mediaQuery = null;
        const handleUpdate = () => {
            setPixelRatio(window.devicePixelRatio);
            if (mediaQuery != null) {
                mediaQuery.removeListener(handleUpdate);
            }
            mediaQuery =
                window.matchMedia(`(resolution: ${window.devicePixelRatio}dppx)`);
            mediaQuery.addListener(handleUpdate);
        };
        handleUpdate();
        return () => {
            if (mediaQuery != null) {
                mediaQuery.removeListener(handleUpdate);
            }
        };
    }, []);
    return pixelRatio;
}
//# sourceMappingURL=usePixelRatio.js.map